export const LOAD_LEVELS = '[LEVELS] LOAD_LEVELS'
export const LOAD_SPECIAL_LEVELS = '[LEVELS] LOAD_SPECIAL_LEVELS'
export const LOAD_LEVEL_DETAIL = '[LEVELS] LOAD_LEVEL_DETAIL'
export const LOAD_LEVEL_TEMARY = '[LEVELS] LOAD_LEVEL_TEMARY'
export const LOAD_LEVEL_PRICES = '[LEVELS] LOAD_LEVEL_PRICES'
